import { todayIsoDate } from '@/lib/financeStatus';

/**
 * Cota do plano grátis = limite base + bônus de indicação.
 *
 * O bônus é alimentado pela edge function `process-referral` e vive em
 * `profiles.bonus_quotes`. Um valor NÃO-FINITO ali (NaN vindo de uma conta
 * malformada, Infinity de um cálculo que transbordou) fazia a soma virar
 * não-finita — e como toda comparação com NaN é falsa, `contagem >= cota`
 * nunca barrava ninguém: a cota do plano grátis deixava de existir, em
 * silêncio. Por isso o clamp é sobre o RESULTADO, e não só sobre o bônus.
 */
export function getFreeQuoteAllowance(baseLimit: number, bonusQuotes: number | null | undefined): number {
  const base = Number.isFinite(baseLimit) ? baseLimit : 0;
  const bonus = Number.isFinite(bonusQuotes) ? Math.max(0, bonusQuotes as number) : 0;
  return base + bonus;
}

/** First day of the user's local calendar month as a Postgres DATE string. */
export function getQuotePeriodStart(date: Date = new Date()): string {
  return `${todayIsoDate(date).slice(0, 7)}-01`;
}

/**
 * DATE columns are civil dates, not UTC instants. Compare their ISO date parts
 * directly so UTC-3 can never move a period to the previous day/month.
 */
export function isCurrentQuotePeriod(
  periodStart: string | null | undefined,
  currentPeriodStart: string = getQuotePeriodStart(),
): boolean {
  return periodStart?.slice(0, 10) === currentPeriodStart;
}

export function getCurrentPeriodValue(
  value: number | null | undefined,
  periodStart: string | null | undefined,
  currentPeriodStart: string = getQuotePeriodStart(),
): number {
  if (!isCurrentQuotePeriod(periodStart, currentPeriodStart)) return 0;
  return Math.max(0, value ?? 0);
}
